module.exports = __webpack_public_path__ + "img/圆柱形读卡器 (4).1adcf5b8.jpg";